import { Ok, Result } from 'ts-res';
import { KameleoonData } from 'src/kameleoonData/types';
import { KameleoonError } from 'src/kameleoonError';
import { EvaluationDataType, MatchType } from 'src/targeting/types';
import { ConditionDataType, ICondition } from './types';
import { KameleoonLogger } from 'src/logging';

export class SameDayVisits implements ICondition {
  private matchType?: MatchType | null;
  private conditionValue?: number | null;

  constructor({ matchType, visitCount }: ConditionDataType) {
    this.matchType = matchType;
    this.conditionValue = visitCount;
  }

  public evaluate({
    targetingData,
    sdkInfo,
  }: EvaluationDataType): Result<boolean, KameleoonError> {
    const visitsData = targetingData?.[KameleoonData.VisitsData];

    if (!visitsData) {
      return Ok(false);
    }

    let todayVisits = 0;

    const todayTimestamp = new Date().setHours(0, 0, 0, 0);
    const { visits } = visitsData;

    visits.forEach((item) => {
      let timeStarted;
      if (typeof item === 'number') {
        timeStarted = item;
      } else {
        timeStarted = item.timeStarted;
      }

      if (timeStarted >= todayTimestamp) {
        todayVisits++;
      }
    });

    if (sdkInfo.isServer) {
      // --- Note ---
      // +1 is current visit
      todayVisits += 1;
    }

    return Ok(this.checkCondition(todayVisits));
  }

  private checkCondition(todayVisitsAmount: number): boolean {
    if (!this.matchType || typeof this.conditionValue !== 'number') {
      return false;
    }

    switch (this.matchType) {
      case MatchType.EQUAL:
        return todayVisitsAmount === this.conditionValue;
      case MatchType.GREATER:
        return todayVisitsAmount > this.conditionValue;
      case MatchType.LOWER:
        return todayVisitsAmount < this.conditionValue;
      default:
        KameleoonLogger.error`Unexpected comparing operation for SameDayVisits condition: ${this.matchType}`;
        return false;
    }
  }
}
